module.exports = __webpack_public_path__ + "images/emoji/non-potable_water.ff770892bbb28bc9879d.png";